import { render, staticRenderFns } from "./PromoItem.vue?vue&type=template&id=49255bfc&"
import script from "./PromoItem.vue?vue&type=script&lang=js&"
export * from "./PromoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports